import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/orderComment/page', data, {
    trim: true
  })
}

export function updateById (data) {
  return request.post('/business/orderComment/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/orderComment/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/orderComment/delete/batch', {
    params: {
      ids
    }
  })
}
